import { render } from "./NotFound.vue?vue&type=template&id=eef94728&ts=true"
import script from "./NotFound.vue?vue&type=script&lang=ts"
export * from "./NotFound.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\y-sakakibara\\Documents\\Git\\workflow-system\\workflow\\frontend\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__